export default __webpack_public_path__ + "static/media/Railway Station - Xiva.d691db96.jpg";